<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && tool">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<p>{{tool.shortdesc}}</p>
						<table
							class="table"
							*ngIf="tool">
							<tbody>
								<tr *ngIf="tool.id">
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ tool.id }}</td>
								</tr>
								<tr *ngIf="tool.name">
									<td>{{ 'labels.name' | translate }}</td>
									<td>{{ tool.name }}</td>
								</tr>
								<tr *ngIf="company.name">
									<td>{{'labels.company' | translate }}</td>
									<td>{{ company.name }}</td>
								</tr>
								<tr *ngIf="tool.value">
									<td>{{'labels.value' | translate }}</td>
									<td>{{ tool.value | currency:'EUR' }}</td>
								</tr>
								<tr *ngIf="tool.yearlyvalue">
									<td>{{'labels.yearlyvalue' | translate }}</td>
									<td>{{ tool.yearlyvalue | currency:'EUR' }}</td>
								</tr>
								<tr *ngIf="tool.depreciationstart">
									<td>
										{{'labels.depreciationstart' | translate }}
									</td>
									<td>
										{{ tool.depreciationstart | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr *ngIf="tool.depreciationend">
									<td>
										{{'labels.depreciationend' | translate }}
									</td>
									<td>
										{{ tool.depreciationend | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr *ngIf="tool.insdate">
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ tool.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<tr *ngIf="tool.moddate">
									<td>{{'labels.moddate' | translate }}</td>
									<td>
										{{ tool.moddate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<div class="row mt-1">
									<div class="col">
										<button
											(click)="edit()"
											class="btn btn-primary">
											{{'labels.edit' | translate | titlecase}}
										</button>
									</div>
								</div>
							</tbody>
						</table>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : tool?.companyid}"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="tool"
							[bootstrap]="true"
							[eid]="tool.id"></app-attachments>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="utilization">
					<a
						routerLink="."
						fragment="utilization"
						ngbNavLink>
						Utilizzo
					</a>
					<ng-template ngbNavContent>
						<app-tool-activity-use [tool]="tool"></app-tool-activity-use>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">{{'errors.loading.tool' | translate}}</app-card>

	</div>
</div>
